import { gql } from 'apollo-angular';

export const LIST_CUSTOMERS = gql`
  query customers($search: String) {
    customers(search: $search) {
      id
      firstName
      lastName
      email
      phoneNumber
      address
      city
      state
      country
      zipCode
      gender
      dateOfBirth
    }
  }
`;

export const FETCH_CUSTOMER = gql`
  query customer($id: Int!) {
    customer(id: $id) {
      id
      firstName
      lastName
      email
      phoneNumber
      address
      city
      state
      country
      zipCode
      gender
      dateOfBirth
      preferences
      branchId
      branchData {
        id
        branchName
        address
        branchCode
      }
      customerDocs {
        id
        documentType
        documentName
        issueDate
        expiryDate
        isActive
        uploadedFile
      }
      status
    }
  }
`;

export const FETCH_PARTNER = gql`
  query partner($id: Int!) {
    partner(id: $id) {
      id
      partnerType
      customerType
      displayName
      companyName
      email
      phone
      mobile
      currency
      emirateID
      trnNumber
      openingBalance
      paymentStatus
      paymentTerm
      status
      primaryContactId
      primaryContact {
        id
        salutation
        firstName
        lastName
        email
        phone
        mobile
        primaryContact
        status
        partnerId
      }
      contacts {
        id
        salutation
        firstName
        lastName
        email
        phone
        mobile
        primaryContact
        status
        partnerId
      }
      invoices {
        id
        # projectId
        quoteId
        partnerId
        billingAddressId
        shippingAddressId
        invoiceNo
        # orderNo

        invoiceDate
        paymentTerm
        paymentStatus
        reason
        dueDate
        subject
        customerNote
        isPayment
        subTotal
        tax
        adjustment
        totalPrice
        status
        createdAt
        updatedAt
        deletedAt
      }
      sales {
        id
        # projectId
        partnerId
        shippingAddressId
        billingAddressId
        quoteId
        orderId
        reference
        orderDate
        expectedDate
        paymentTerm
        customerNote
        subTotal
        tax
        adjustment
        totalPrice
        status
        createdAt
        updatedAt
        deletedAt
      }
      remarks {
        id
        remarkContent
        status
        createdAt
        updatedAt
        deletedAt
      }
      addresses {
        id
        partnerId
        attention
        addressType
        addressLine1
        addressLine2
        city
        state
        country
        pinCode
        phone
        fax
      }
      documents {
        id
        partnerId
        documentName
        documentUrl
        createdAt
        updatedAt
        deletedAt
      }
    }
  }
`;

export const PARTNER_DETAILS = gql`
  query partnerDetails($id: Int!, $startDate: String, $endDate: String) {
    partnerDetails(id: $id, startDate: $startDate, endDate: $endDate) {
      partner {
        id
        partnerType
        customerType
        displayName
        companyName
        email
        phone
        mobile
        currency
        emirateID
        trnNumber
        openingBalance
        paymentStatus
        paymentTerm
        status
        primaryContactId
        documents {
          id
          documentName
          documentUrl
        }
        # primaryContact
        contacts {
          salutation
          firstName
          lastName
          phone
          mobile
          email
        }
        # sales
        # projects
        remarks {
          remarkContent
        }
        addresses {
          attention
          addressType
          addressLine1
          addressLine2
          state
          country
          pinCode
        }
      }
      billTotal
      paymentTotal
      balanceDue
      invoiceTotal
      combinedTransactions {
        type
        date
        totalPrice
        balance
        description
        refNo
        chequeNumber
        billBalanceAmount
        billPaidAmount
        billData {
          purchaseOrderData {
            purchaseOrderNo
          }
        }
        project
        projectCode
      }
    }
  }
`;

export const COMMENTS = gql`
  query comments($conditions: CommentConditionsInput) {
    comments(conditions: $conditions) {
      id
      employeeId
      employee {
        id
        firstName
        lastName
        middleName
        dateOfBirth
        gender
        email
        phoneNumber
        alternatePhoneNumber
        address
        permanentAddress
        nativeAddress
        dateOfJoining
        employmentType
        employeeType
        employeeStatus
        profilePicture
        maritalStatus
        nationality
        passportNumber
        visaType
        visaIssueDate
        visaExpiryDate
        salary
        bankName
        bankAccountNumber
        IFSCCode
        isPortalUser
        reportingManagerId
        # reportingManager
        # comments
      }
      refId
      type
      activityType
      note
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GENERATE_STATEMENT_PDF = gql`
  query generatePartnerStatementPdf(
    $id: Int!
    $startDate: String
    $endDate: String
  ) {
    generatePartnerStatementPdf(
      id: $id
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

export const PARTNER_BILLS = gql`
  query findOnePartnerForBills($id: Int!) {
    findOnePartnerForBills(id: $id) {
      id
      bills {
        id
        billNo
        # orderNo
        purchaseOrderData {
          purchaseOrderNo
          # billDate
          totalPrice
        }
        projectModelData {
          projectName
        }
        totalPrice
        balance
        billStatus
        billDate
        partnerData {
          displayName
        }
        status
      }
    }
  }
`;
export const PARTNER_INVOICES = gql`
  query findOnePartnerForInvoices($id: Int!) {
    findOnePartnerForInvoices(id: $id) {
      id
      invoices {
        balance
        totalPrice
        adjustment
        subTotal
        dueDate
        paymentStatus
        orderNo
        invoiceDate
        invoiceNo
      }
    }
  }
`;
export const PARTNER_JOURNAL_ENTRIES = gql`
  query findOnePartnerForJournalEntries($id: Int!) {
    findOnePartnerForJournalEntries(id: $id) {
      id
      JournalEnteries {
        journalId
        Journal {
          journalNo
        }
        description
        debit
        credit
        createdAt
      }
    }
  }
`;
export const PARTNER_PURCHASE_ORDERS = gql`
  query findOnePartnerForPurchaseOrders($id: Int!) {
    findOnePartnerForPurchaseOrders(id: $id) {
      id
      purchaseOrder {
        id
        purchaseOrderNo
        totalPrice
        billDate
        purchaseStatus
      }
    }
  }
`;
export const PARTNER_NOTES = gql`
  query findOnePartnerForNotes($id: Int!) {
    findOnePartnerForNotes(id: $id) {
      id
      notes {
        noteType
        totalPrice
        noteNo
        noteDate
      }
    }
  }
`;
export const PARTNER_QUOTES = gql`
  query findOnePartnerForQuotes($id: Int!) {
    findOnePartnerForQuotes(id: $id) {
      id
      quotes {
        totalAmount
        quoteCode
        quoteDate
        quoteType
        quoteTitle
      }
    }
  }
`;
export const PARTNER_WORK_ORDERS = gql`
  query findOnePartnerForWorkorders($id: Int!) {
    findOnePartnerForWorkorders(id: $id) {
      id
      workOrders {
        totalAmount
        workOrderNo
        workOrderStatus
      }
    }
  }
`;
export const PARTNER_PAYMENTS = gql`
  query findOnePartnerForPayments($id: Int!) {
    findOnePartnerForPayments(id: $id) {
      id
      payments {
        id
        paymentNo
        branchId
        referenceNo
        totalAmount
        bankCharge
        paymentMode
        paymentDate
        note
        deposit {
          accountName
          accountType
          accountCode
        }
        paymentInfo {
          refType
        }
      }
    }
  }
`;



export const LEAD = gql`
  query lead($id: Int!) {
    lead(id: $id) {
      id
      branchID
      assignedTo
      assignedToData {
        id
        firstName
        lastName
      }
      leadName
      email
      phone
      source
      status
      industry
      companyName
      expectedValue
      expectedCloseDate
      notes
      # customerId
      probability
      createdAt
      updatedAt
    }
  }
`;
